import { render } from "./RedPointAlert.vue?vue&type=template&id=4a047e57&scoped=true&ts=true"
import script from "./RedPointAlert.vue?vue&type=script&lang=ts"
export * from "./RedPointAlert.vue?vue&type=script&lang=ts"

import "./RedPointAlert.vue?vue&type=style&index=0&id=4a047e57&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a047e57"]])

export default __exports__